module.exports = __webpack_public_path__ + "img/08_no.2492832c.svg";